export const FETCH_PARTNER_REQUEST = 'FETCH_PARTNER_REQUEST';
export const FETCH_PARTNER_SUCCESS = 'FETCH_PARTNER_SUCCESS';
export const FETCH_PARTNER_FAILURE = 'FETCH_PARTNER_FAILURE';
